import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';

// Render embedded inline entries
// Contentful allows you to embed entries within rich text fields
// This component handles rendering those embedded entries
// e.g. enhanced links
const EmbeddedInlineEntry = ({ entry }) => {
  // Check the content type ID or other fields to determine how to render it
  const contentTypeId = entry?.sys?.contentType?.sys?.id ?? 'unknown';
  const { title } = entry.fields; 

  switch (contentTypeId) {
    case 'enhancedLink':
      // Example: Render a link with the entry's title
      return <a target={entry?.fields?.openInNewWindow ? '_blank' : ''} title={`${entry?.fields?.name}`} href={`${entry?.fields?.url}`}>{`${entry?.fields?.name}`}</a>;
    case 'myTag':
      // Example: Render a simple tag/chip
      return <span className="tag">{title}</span>;
    default:
      return <span className="unknownInline"></span>;
  }
};

const renderOptions = {
  renderNode: {
    'embedded-asset-block': (node) => {
      return <img className="content-img" src={node.data.target.fields.file.url}/>
    },
    [INLINES.EMBEDDED_ENTRY]: (node) => {
      // The entry data should be directly in node.data.target if it was resolved
      const entry = node.data.target;

      if (entry && entry.sys && entry.sys.contentType) {
        return <EmbeddedInlineEntry entry={entry} />;
      }
      
      // Fallback if the entry data isn't resolved (you might need to fetch it here 
      // if you couldn't resolve all levels, but fetching outside is recommended)
      return <span>[Entry ID: {node.data.target.sys.id} not found]</span>;
    },
  },
}

function RenderRichText(content){
  return documentToReactComponents(content, renderOptions)
}

export default RenderRichText
